const BUILD = {
  LIBRARY_NAME: 'dataload-utility',
  BASE_URL: '/api',
  GA_ID: '',
  HORIZON_SUBDOMAIN: 'luigi',
};

module.exports = BUILD;
